import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2';

$(document).ready(function() {

	const bookings = {
        isLoading: false,
		type: null,
		date: null,
		time: null,
        init() {
            $(document).on('click', 'a[href="{booking}"]', this, this.openModal);
            $(document).on('click', '.booking-open-btn', this, this.openModal);
            $(document).on('click', '#booking-send-btn', this, this.send);
            $(document).on('click', '.booking-type', this, this.selectType);
            $(document).on('click', '.booking-select-time-btn', this, this.selectTime);
            $(document).on('click', '.booking-confirm-select-time-btn', this, this.confirmDateAndTime);
            $(document).on('click', '#booking-back-btn', this, function() {
				$('.modal-calendar').show();
				$('.modal-form').hide();
				$('#booking-back-btn').hide();
				$('#booking-modal').find('.modal-dialog').removeClass('modal-xl').addClass('modal-lg');
			});
            $(document).on('click', '#booking-widget-back-btn', this, function() {
				$('.modal-calendar').show();
				$('.modal-form').hide();
				$('#booking-widget-back-btn').hide();
				$('#booking-widget').find('.modal-dialog').removeClass('modal-xl').addClass('modal-lg');
			});
        },
		initWidget() {
			var _this = this;

			var disabledDatesAndTime = $('#booking-widget').data('disabled-days');

			$('#booking-calendar').datepicker({
				startDate: '-0d',
				weekStart: 1,
				language: 'ro-RO',
				daysOfWeekDisabled: [0,6],
				maxViewMode: 0,
				datesDisabled: disabledDatesAndTime.days
			}).on('changeDate', function(e) {
				$('.calendar-date').text(e.format('DD, MM d'));
				$('.booking-summary .date').text(e.format('DD, MM d'));
				e.data = _this;
				e.source = 'widget';
				_this.selectDate(e);
				_this.confirmDateAndTime(e);

				$('.booking-time-wrapper').show();
				for (var h in disabledDatesAndTime.hours[e.format('dd-mm-yyyy')]) {
					var timeId = disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h];
					//console.log(disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h]);
					$('#time-' + disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h]).hide();
					//console.log($('#time-' + timeId).length);
					//console.log($('.booking-time-wrapper').length);
				}
			});
		},
		confirmDateAndTime(event) {
			const _this = event.data;

			var elementId = '#booking-modal';
			if (event.source == 'widget') {
				elementId = '#booking-widget';
			}

			// if (_this.type ==  null || _this.type == '') {
			// 	Swal.fire({
			// 		//icon: "success",
			// 		title: $('#booking-modal').data('booking-error-title'),
			// 		html: $('#booking-modal').data('booking-type-error')
			// 	});
			// 	return;
			// }
			if (_this.date ==  null || _this.date ==  '') {
				Swal.fire({
					//icon: "success",
					title: $(elementId).data('booking-error-title'),
					html: $(elementId).data('booking-date-error')
				});
				return;
			}
			// if (_this.time ==  null || _this.time ==  '') {
			// 	Swal.fire({
			// 		//icon: "success",
			// 		title: $('#booking-modal').data('booking-error-title'),
			// 		html: $('#booking-modal').data('booking-time-error')
			// 	});
			// 	return;
			// }

			//$('.booking-description').hide();
			$('.booking-summary').show();

			$('.modal-calendar').hide();
			$('.modal-form').show();
			$('.booking-back-btn').show();
		},
		selectDate(event) {
			if (typeof event === 'object') {
				this.date = event.format('yyyy-mm-dd');
			} else {
				this.date = event;
			}

			var elementId = '#booking-modal';
			if (event.source == 'widget') {
				elementId = '#booking-widget';
			}

			$(elementId).find('.modal-dialog').removeClass('modal-lg').addClass('modal-xl');
		},
		selectTime(event) {
			const _this = event.data;

			var time = $(this).data('time');

			$('.booking-time-container').find('.booking-time-wrapper').removeClass('active');
			$(this).parent().addClass('active');

			_this.time = time;
			var endTime = _this.time + 1;
			$('.booking-summary .time').text(_this.time+':00 - '+endTime+':00');
		},
		selectType(event) {
			const _this = event.data;

			var type = $(this).data('type');

			$('.booking-type').removeClass('active');
			$(this).addClass('active');

			_this.type = String(type);
		},
		openModal(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
	            console.log('is loading...');
	            return false;
	        }

			_this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			$.ajax({
	            type: "GET",
	            url: baseURL + "/bookings/open",
	            //data: values,
	            success: function(html) {
					_this.isLoading = false;
					$(element).find('i').hide();

					$('#modal-id').html(html);
					var disabledDatesAndTime = $('#booking-modal').data('disabled-days');

					$('#booking-modal').modal('show');
					$('#booking-modal').on('shown.bs.modal', function (e) {
						$('#booking-calendar').datepicker({
							startDate: '-0d',
							weekStart: 1,
							language: 'ro-RO',
							daysOfWeekDisabled: [0,6],
							maxViewMode: 0,
							datesDisabled: disabledDatesAndTime.days
						}).on('changeDate', function(e) {
							$('.calendar-date').text(e.format('DD, MM d'));
							$('.booking-summary .date').text(e.format('DD, MM d'));
							_this.selectDate(e.format('yyyy-mm-dd'));
							_this.confirmDateAndTime(event);

							$('.booking-time-wrapper').show();
							for (var h in disabledDatesAndTime.hours[e.format('dd-mm-yyyy')]) {
								var timeId = disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h];
								//console.log(disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h]);
								$('#time-' + disabledDatesAndTime.hours[e.format('dd-mm-yyyy')][h]).hide();
								//console.log($('#time-' + timeId).length);
								//console.log($('.booking-time-wrapper').length);
							}
					    });
					});

					$('#booking-modal').on('hidden.bs.modal', function() {
						_this.type = null;
						_this.time = null;
						_this.date = null;
					});

					//console.log(disabledDatesAndTime);
	            },
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				}
	        });
		},
		send(event) {
			const _this = event.data;
			let element = this;
			var source = $(element).data('source');

			var elementId = '#booking-modal';
			if (source == 'widget') {
				elementId = '#booking-widget';
			}

			if (_this.isLoading) {
	            console.log('is loading...');
	            return false;
	        }

			// if (_this.type ==  null || _this.type == '') {
			// 	Swal.fire({
			// 		//icon: "success",
			// 		title: "Eroare!",
			// 		html: 'Va rugam selectati metoda: zoom sau office!'
			// 	});
			// 	return;
			// }
			if (_this.date ==  null || _this.date ==  '') {
				Swal.fire({
					//icon: "success",
					title: $(elementId).data('booking-error-title'),
					html: $(elementId).data('booking-date-error')
				});
				return;
			}
			// if (_this.time ==  null || _this.time ==  '') {
			// 	Swal.fire({
			// 		//icon: "success",
			// 		title: $('#booking-modal').data('booking-error-title'),
			// 		html: $('#booking-modal').data('booking-time-error')
			// 	});
			// 	return;
			// }

			var error = false;
			$('.booking-form').find('.form-control').removeClass('is-invalid');
			$('.booking-form').find('.form-check-input').removeClass('is-invalid');
			//$('#bookings-form-error-msg').hide();

			if ($('#booking_name').val() == '') {
				$('#booking_name').addClass('is-invalid');
				error = true;
			}
			if ($('#booking_email').val() == '') {
				$('#booking_email').addClass('is-invalid');
				error = true;
			}
			// if ($('#booking_company').val() == '') {
			// 	$('#booking_company').addClass('is-invalid');
			// 	error = true;
			// }
			if ($('#booking_message').val() == '') {
				$('#booking_message').addClass('is-invalid');
				error = true;
			}
			if (!$('#booking_terms_and_conditions').is(':checked')) {
				$('#booking_terms_and_conditions').addClass('is-invalid');
				error = true;
			}
			if (error) {
				return false;
			}

			_this.isLoading = true;
			$(element).find('i').show();

			var values = 'date=' + _this.date;
			values += '&time=' + _this.time+':00';
			values += '&type=' + _this.type;
			values += '&name=' + $('#booking_name').val();
			values += '&email=' + $('#booking_email').val();
			values += '&phone=' + $('#booking_phone').val();
			values += '&company=' + $('#booking_company').val();
			values += '&job=' + $('#booking_job').val();
			values += '&message=' + $('#booking_message').val();
			values += '&_token=' + $("meta[name='csrf-token']").attr("content");
	        $.ajax({
	            type: "POST",
	            url: baseURL + "/bookings/send",
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
						for(var errorKey in response.errors) {
							if(!response.errors.hasOwnProperty(errorKey)) continue;
							for(var error in response.errors[errorKey]) {
								$("#booking_"+errorKey).addClass('is-invalid');
								errorHtml += response.errors[errorKey][error] + '<br>';
							}
						}

						//$('#bookings-form-error-msg').html(errorHtml);
                        //$('#bookings-form-error-msg').fadeIn();
						Swal.fire({
							//icon: "success",
							title: "Eroare!",
							html: errorHtml
						});
						return false;
					}

					if (response.status == 1) {
						//$('.booking-form').find('.form-control').val('');
						//$('#booking_terms_and_conditions').attr('checked', false);

						if (source == 'widget') {
							$('.booking-widget-container').html(`<div class="modal template-confirmation" style="display: block; position: unset;" id="booking-widget-confirmation" tabindex="-1" aria-hidden="true">
								<div class="modal-dialog modal-dialog-centered">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title mx-auto">${response.title}</h5>
										</div>
										<div class="modal-body text-center">
											<p>${response.message_2}</p>
										</div>
									</div>
								</div>
							</div>`);
							return;
						}

						$('#booking-modal').modal('hide');
						$('#booking-modal').on('hidden.bs.modal', function() {
							$('#modal-id').html('');

							$('#modal-id').html(`<div class="modal template-confirmation fade" id="booking-modal-confirmation" tabindex="-1" aria-hidden="true">
					            <div class="modal-dialog modal-dialog-centered">
					                <div class="modal-content">
					                    <div class="modal-header">
					                        <h5 class="modal-title mx-auto">${response.title}</h5>
					                        <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"><i class="fal fa-times"></i></button>
					                    </div>
					                    <div class="modal-body text-center">
					                        <p>${response.message_2}</p>
					                    </div>
					                </div>
					            </div>
					        </div>`);
							$('#booking-modal-confirmation').modal('show');
						});
						return;
					}
	            },
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				}
	        });
		},
	};

    bookings.init();

	if ($('#booking-widget').length > 0) {
		bookings.initWidget()
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/bookings.js